import { Reveal } from "@/components/site/Reveal";
import { SectionLabel, Catalog, SubpageBanner } from "@/components/att/ATTShared";

export default function ATTDevicesPage() {
  return (
    <div className="py-14 md:py-20" data-testid="att-devices-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-10">
        <Reveal>
          <SubpageBanner src="/att/og-devices.jpg" alt="iPhone 18 Pro lineup in four colors" testid="att-devices-banner" />
        </Reveal>
        <Reveal>
          <SectionLabel>Devices &amp; Equipment</SectionLabel>
          <h1 className="mt-4 font-serif-display text-4xl sm:text-5xl font-bold tracking-tight text-[#1d2329]">Shop the latest devices.</h1>
          <p className="mt-3 max-w-2xl font-body font-light text-base text-[#3c4650]">
            Every color, every storage size, every price — pick what you want, then lock it in on the pre-order form
            and we'll apply every promo you qualify for.
          </p>
        </Reveal>
        <Catalog audience="all" />
      </div>
    </div>
  );
}
